// Funkcia zabezpecuje flow pri vyskladavani sportsbook menu
sportsbook = {
    wholeMenuHandler(menuSection, data, pointer) {
        try {
            stored.allMenu = data.slice(); // TODO - zjednotit s cache.wholeMenu?
            var dataSports = data.filter(function (item) {
                return item.Typ === "SP" || item.Typ === "FASP" || item.Typ === "SE" || item.Typ === "GS";
            });
            if (stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID && stored.PlayerFavorite && stored.UserSettings.Original.favoriteSportLeague === "1") {
                dataSports.unshift({
                    Typ: "FA",
                    ID: 0,
                    Name: texts.SportsbookRootFavorites,
                    EventCount: 0,
                    Order: 1
                });
            }
            
            switch(menuSection) {
                case "sportsBook":
                    // Render sportov
                    // uloženie súčtu ponuky udalostí v aktuálnom menu pre ošetrenie chovania tlačidla "Zobraziť viac udalostí"
                    stored.allMenuSum = dataSports.reduce(function(acc, sport) {
                        return acc + sport.EventCount;
                    }, 0);
                    sportsbook.sportsBookRender(dataSports);
                    delete cache.wholeMenu;
                    break;
                    
                case "sportsBookRegions":
                    if (pointer === "FA0") {
                        // Render oblubenych sportov
                        $("#sportsBook").addClass("ui-disabled");
                        var sports = Object.values(stored.allSports).filter(function(sport) {
                            return Object.keys(stored.PlayerFavorite.pFavorites).includes(String(sport.ID))
                        }).sort(function(sportA, sportB) {
                            return sportA.Order - sportB.Order;
                        });
                        sportsbook.sportsBookRenderRL("a", sports, pointer);
                    } else {
                        // Render regionov
                        shared.scrollModule.scrollReload("sportsBookEventsFavorites", "clear");
                        sportsbook.sportsBookRenderRL("a", data.filter(function(item) {
                            if ((item.Typ === "RE" && item.ParentID === offer.sportID)) {
                                return item;
                            } else if ((item.Typ === "SX" && item.ParentID === offer.sportEventID)) {
                                item.Typ = "SP";
                                return item;
                            }
                        }), pointer);
                    }
                    // z nejakeho dovodu niekedy dostanem offer.pointer=null
                    offer.pointer && shared.scrollModule.scrollPage('offer', $("#sportsBook #" + offer.pointer).offset().top - 230, 'slow');
                    delete cache.wholeMenu;
                    break;

                case "sportsBookLeagues":
                    var dataLeagues;
                    // Priradi docasny pointer pre render "sportsBookRegions"
                    var sportsBookTempPointer = String(offer.pointer);
                    if (offer.pointer.replace(/\d/g, '') === "FASP") {
                        // Render oblubenych regionov
                        offer.sportID = parseInt(offer.pointer.replace(/\D/g, ''));
                        if (stored.PlayerFavorite.pFavorites[offer.sportID].playerLeagues && Object.keys(stored.PlayerFavorite.pFavorites[offer.sportID].playerLeagues)) {
                            // Vybrane ligy
                            dataLeagues = Object.values(stored.PlayerFavorite.pFavorites[offer.sportID].playerLeagues).sort(function(a, b) {
                                return a.Order - b.Order;
                            });
                        } else if (stored.PlayerFavorite.pFavorites[offer.sportID].allLeaguesFlat) {
                            // Vsetky ligy
                            dataLeagues = Object.values(stored.PlayerFavorite.pFavorites[offer.sportID].allLeaguesFlat).sort(function(a, b) {
                                return a.Order - b.Order;
                            });
                        }
                    } else if (offer.sportEventID > 0) {
                        // Render sportovych udalosti - ligy
                        shared.scrollModule.scrollReload("sportsBookEventsFavorites", "clear");
                        dataLeagues = data.filter(function(item) {
                            return ((item.Typ === "LX" && item.ParentID === offer.SeSpID));
                        });
                    } else if (offer.pointer === "GS1") {
                        // Render zlatej ligy - ligy
                        shared.scrollModule.scrollReload("sportsBookEventsFavorites", "clear");
                        dataLeagues = data.filter(function(item) {
                            return ((offer.goldenLeague && item.Typ === "GL" && item.ParentID === 1));
                        });
                    } else {
                        // Render struktury sport - region - liga
                        shared.scrollModule.scrollReload("sportsBookEventsFavorites", "clear");
                        dataLeagues = data.filter(function(item) {
                            return ((item.Typ === "LC" && item.ParentID === offer.regionID));
                        });
                        // Render regionov
                        // TODO - treba toto?
                        //sportsbook.wholeMenuHandler("sportsBookRegions", data, "SP" + offer.sportID);
                    }
                    // Vrati spat povodny pointer
                    offer.pointer = String(sportsBookTempPointer);
                    events.eventsSignalrModule.setMultiView(dataLeagues);
                    // Render ligy - pouzije sportsBookTempPointer aby sa zabranilo race condition
                    sportsbook.sportsBookRenderRL("b", dataLeagues, sportsBookTempPointer);
                    // z nejakeho dovodu niekedy dostanem offer.pointer=null
                    offer.pointer && shared.scrollModule.scrollPage('offer', $("#sportsBook #" + offer.pointer).offset().top - 230, 'slow');
                    delete cache.wholeMenu;
                    break;
            }
        } catch (e) {
            delete cache.wholeMenu;
            $("#sportsBook").removeClass("ui-disabled");
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia po zatvoreni nacita data pre uroven vyssie
    // TODO - zjednotit s on2ndLevelToggle a on3rdLevelToggle? - mozno to pojde cele prec
    levelUp(level) {
        if (stored.actionsHandling.scrolledByTapAndHold) {
            stored.actionsHandling.scrolledByTapAndHold = false;
            main.userAction();
            return false;
        }
        // Samostatny tread popri collapse
        setTimeout(function () {
            shared.scrollModule.scrollReload("sportsBookEventsFavorites", "clear");
            //$("#sportsBook, #events").addClass("ui-disabled");
            $(level).find("summary").removeAttr("onclick");
            // Ak sa jedna o prvu uroven (SE / SP)
            if (!level || $(level).hasClass("SB-level-root")) {
                // Odznaci buttony v liste a vyskroluje hore
                $("#showAllEvents, #tableBottom .arrows").hide();
                // Skryje plachtu
                $("#noEvents").show();
                // Odstrani ikonu sportu v hlavicke ponuky
                $("#tableTop .table-icon").removeClass().addClass("table-icon");
                if (profile.ExtendedActualOffer) {
                    $($("#events #section .events-list")[0]).removeClass("virtuals-octava events-no-master-view events-sexta-view events-duo-view");
                    $('#sportBox .content-table').parent().removeClass('is-victoria is-no-master is-duo is-sexta exclude-12');
                    setTimeout(function () {
                        $("#section").removeClass("scroll-offer");
                    }, 0);
                }
                $("#events #section").empty();
                // Nacita nove data
                service.loadPure('sportsBook');
                shared.scrollModule.scrollPage('offer', 'top', 'slow');
                // Popisky
                switch (offer.date) {
                    case "L1H":
                    case "L3H":
                    case "L6H":
                    case "L12H":
                        $("#offerTop").text(texts.HeaderLabelStartingMatches);
                        break;
                    case "TD":
                        $("#offerTop").text(texts.HeaderLabelToday);
                        break;
                    case "TM":
                        $("#offerTop").text(texts.HeaderLabelTomorrow);
                        break;
                    default:
                        if (offer.onlyLive == -1) {
                            if (offer.page === "results") {
                                $("#offerTop").text(texts.FooterLabelResults);
                            } 
                            if (offer.page === "otherDates") {
                                $("#offerTop").text(texts.HeaderLabelOtherDates);
                            }
                        } else {
                            $("#offerTop").text(texts.HeaderLabelLive);
                        }
                        break;
                }
                $("#tableTop .table-title").empty();

                // Zatvorenie tabulky na top screene
                communication.statsTable(false);
            // TODO preverit offer.goldenLeague ci mozu ist prec
            } else if (offer.goldenLeague || $(level).hasClass("SB-level-a")) {
                // Ak sa jedna o druhu uroven (RE) alebo GoldenLeague
                shared.scrollModule.scrollReload("sportsBookEventsFavorites", "clear");
                service.loadPure('sportsBookRegions', ($(level).parents(".SB-level-root").attr("id")));
            } else {
                // Ak sa jedna o tretiu uroven (LC)
                service.loadPure('sportsBookLeagues', ($(level).parents(".SB-level-a").attr("id")));
            }

        }, 200);
    },

    // Funkcia na zobrazenie filtra v menu "zacinajuce zapasy" a "neskor"
    renderFilterForMatches() {
        if (offer.page === "lastMinute" || offer.page === "otherDates" || offer.page === "results")
            stored.isMatchesFilterActive = true;

        switch (offer.page) {
            case "lastMinute":
                $("#eventsFilter a").each(function (buttonIndex, filterButton) {
                    $(filterButton).attr('onmousedown', 'sportsbook.matchesFilter("' +
                        offer.lastMinuteHours[buttonIndex] + '", ' + buttonIndex + ')').find('.ui-btn-text').text(offer.lastMinuteHours[buttonIndex].slice(1).toLowerCase());
                });
                break;
            case "otherDates":
                offer.otherOfferDates.forEach(function (dayToFuture, buttonIndex) {
                    var actualDate = sportsbook.getDateAfterDays(dayToFuture).slice(8) + '.' + sportsbook.getDateAfterDays(dayToFuture).slice(5, 7) + '.';
                    if (dayToFuture === 1) actualDate = texts.OfferTM;
                    $('#button' + buttonIndex + 'Filter').attr('onmousedown', 'sportsbook.matchesFilter("' +
                        sportsbook.getDateAfterDays(dayToFuture).replace(/-/g, '') + '", ' + buttonIndex + ')').find('.ui-btn-text').text(actualDate);
                });
                break;
            case "results":
                offer.resultsDates.forEach(function (dayToPast, buttonIndex) {
                    var actualDate = sportsbook.getDateAfterDays(dayToPast).slice(8) + '.' + sportsbook.getDateAfterDays(dayToPast).slice(5, 7) + '.';
                    if (dayToPast === 0) actualDate = texts.OfferTD;
                    $('#button' + buttonIndex + 'Filter').attr('onmousedown', 'sportsbook.matchesFilter("' +
                        sportsbook.getDateAfterDays(dayToPast).replace(/-/g, '') + '", ' + buttonIndex + ')').find('.ui-btn-text').text(actualDate);
                });
                break;
        }
    },

    // Funkcia na zobrazenie konkretneho sportu v offer menu
    offerMenuSelectSport() {
        try {
            if (offer.lastSportID && offer.lastSportID !== "-1") {
                var sportElement = $("#SP" + offer.lastSportID + ".SB-root")[0];
                if (sportElement && !sportElement.open) {
                    sportElement.open = true;
                }
                offer.lastSportID = "-1";
                shared.scrollModule.scrollButtons("offer", sets.offerMenuHeight1920x1080 - 61);
            }
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na renderovanie stromu kurzovej ponuky
    sportsBookRender(data) {
        try {
            if (data && !data.ErrorType) {
                $(".content-offer").addClass("ui-disabled");
                $("#sportsBook, #sportsBookVG, #sportsBookLG").empty();
                // Ak niesu ziadne LIVE zapasy tak zobrazi kompletnu ponuku
                if (!data.length) {
                    if (offer.page == "onlyLive") {
                        modal.showErrObj(2, 5, {err1: texts.LiveBlocked, errType: "LiveBlocked"});
                        main.setPage(2);
                    } else {
                        modal.showErrObj(2, 5, {err1: texts.ServiceBlocked, errType: "ServiceBlocked"});
                        if (offer.page == "sportsBook") {
                            main.setPage(1);
                        } else {
                            main.setPage(2);
                        }
                    }
                } else {
                    // Render
                    directives.sportsBookDirective.sportsBook.render("sportsBook", data);
                    
                    if (player.playerFavoritesModule.favoriteButtonState("menuButtonFav") && !$.isEmptyObject(stored.PlayerFavorite.pFavorites)) {
                        // Zobrazenie/skrytie oblubedych v menu
                        $("#sportsBook #FA0").show();
                    } else {
                        $("#sportsBook #FA0").hide();
                    }
                    // Zobrazenie ponuky
                    $("#sportsBook, #events").show();
                    $("#home, #empty, #sportsBookVG, #sportsBookLG").hide();
                }
                // Zobrazi/Skryje v sportbooku posuvne tlacitka hore/dole

                if (stored.isMatchesFilterActive) {
                    // scroll pre 'zacinajuce zapasy' menu obsahuje EventsFilter
                    shared.scrollModule.scrollButtons("offer", sets.offerMenuHeight1920x1080 - 61);
                } else {
                    // scroll pre ponuku s plnou vyskou menu neobsahuje EventsFilter
                    shared.scrollModule.scrollButtons("offer", sets.offerMenuHeight1920x1080);
                }
                $(".content-offer").removeClass("ui-disabled");
                return true;
            } else {
                main.setPage(1);
                $(".content-offer").removeClass("ui-disabled");
                modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.setPage(1);
            $(".content-offer").removeClass("ui-disabled");
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return false;
        }
    },

    // Funkcia na renderovanie KURZOVEJ PONUKY (druha a tretia uroven)
    sportsBookRenderRL(sub, data, customPointer) {
        try {
            if (customPointer) {
                offer.pointer = customPointer;
            }
            if (offer.pointer && data && !data.ErrorType && data.length) {
                // Render
                var targetElement = $("#sportsBook #" + offer.pointer);
                targetElement.children().filter(function() { return this.nodeType === 3 || this.nodeName !== 'SUMMARY'; }).remove();
                $.each(data, function (i, RL) {
                    if (RL.Order != -1) {
                        // Ak sa jedna o SportEvent tak do pointer doplni SE
                        var pointerCheck = String(offer.pointer.replace(/\d/g, ''));
                        if (pointerCheck === "SE") {
                            RL.Typ = "SE" + RL.Typ;
                        } else if (pointerCheck === "FA") {
                            RL.Typ = "FA" + RL.Typ;
                        }
                        // Render jednotlivych regionov alebo lig
                        var statsIco = "";
                        if (profile.ShowStatistics) {
                            if (profile.StatisticsParameter === "hasBetradarHostedStatistics" && RL.CurrentSeasonID) {
                                if ((RL.Typ == "RE") || (RL.Typ == "GL")) statsIco = '<span class="stats-table-ico stats-region"></span>';
                                else if (RL.Typ == "LC") statsIco = '<span class="stats-table-ico" seasonID="' + RL.CurrentSeasonID + '"></span>';
                            }
                            if (profile.StatisticsParameter === "hasStatistics" && RL.HasStatistics) {
                                if (RL.Typ == "RE") statsIco = '<span class="stats-table-ico stats-region"></span>';
                                else if (RL.Typ == "LC") statsIco = '<span class="stats-table-ico" seasonID="' + RL.ID + '"></span>';
                            }
                        }
                        var ontoggleHandler = (sub === 'a') ? 'sportsbook.on2ndLevelToggle(this)' : 'sportsbook.on3rdLevelToggle(this)';
                        targetElement
                            .append(`
                                <details class="SB-level-${sub}" id="${RL.Typ}${RL.ID}" order="${RL.Order}" ontoggle="${ontoggleHandler}">
                                    <summary class="sb-level-${sub}-summary">
                                        <!-- TODO - duplicitne id -->
                                        <span id="SBT${sub}">${RL.Name}</span>
                                        ${statsIco}
                                        <span id="sumRL${sub}" class="${(RL.EventCount > 0)? "ui-li-count": "ui-hidden"} ui-btn-up-c">${RL.EventCount}</span>
                                    </summary>
                                </details>`);
                        // Prida ikonu vlajky
                        if (RL.Typ == "RE") {
                            if (!RL.CountryID) RL.CountryID = 0;
                            $("#sportsBook #RE" + RL.ID).children("summary").prepend('<span class="size33 flag_' + RL.CountryID + '"></span>');
                        }

                        // Prida tymove analyzy pre dany region
                        if (RL.Typ == "RE" && profile.TeamAnalysisRegions.includes(RL.ID) && offer.page !== "results") {
                            targetElement
                                .append('<div id="teamAnalysis" class="team-analysis-RE' + RL.ID + '"><div class="team-analysis-button" onclick="events.showTeamAnalysis(false,' + RL.ID + ')">' + texts.TeamAnalysis
                                    + '</div><div id="teamAnalysisList" style="display: none"><div class="team-analysis-background team-analysis-' + RL.ID + '-' + offer.lang + '">' +
                                    '<div id="triangleTop"></div><div id="teamAnalysisLogos"></div></div></div></div>');
                            events.logosTeamAnalysis(RL.ID);
                        }
                    }
                });

                // Akordeon - zatvori ostatne details elementy (bez odstranenia ich obsahu)
                // TODO - po update EO-browser upravit handlovanie pomocou atributu name
                $("#sportsBook #" + offer.pointer).parent().children("details:not(#" + offer.pointer + ")").removeAttr("open").children("details").removeAttr("open");

                // Nastavi onclick pre levelUp
                $("#sportsBook #" + offer.pointer).children("summary").attr("onclick", "sportsbook.levelUp(" + offer.pointer + ");");
                // Popisky
                if (!offer.goldenLeague) {
                    if (sub == "a") {
                        // Prida do hlavicky ponuky nazov sportu a ikonu sportu
                        $("#tableTop .table-title").html('<span class="table-title-sport">' + $("#" + offer.pointer).find("#offerRoot").attr("sport-name-full") + '</span>');
                        $("#tableTop .table-icon").removeClass().addClass("table-icon sport-icon-" + offer.sportID + " sport-color-" + offer.sportID);
                    } else {
                        var t = '<span class="table-title-sport">'
                            + $("#" + offer.pointer).parents(".SB-level-root").find("#offerRoot").attr("sport-name-full")
                            + '</span><span class="icon-arrow-right"></span>' + $("#" + offer.pointer).find("#SBTa").text();
                        $("#tableTop .table-title").html(t);
                    }
                } else {
                    // Prida do hlavicky ponuky ikonu zlatej ligy
                    $("#tableTop .table-icon").removeClass().addClass("table-icon sport-icon-golden-league sport-color-golden-league");
                    $("#tableTop .table-title").html(texts.OfferGoldenLeague);
                }
                sportsbook.sportsBookSum(sub, data);

                // Zobrazenie tymovej analyzy pre dany region
                if (sub == "b" && offer.pointer != "GL0" && data[1] && profile.TeamAnalysisRegions.includes(data[1].ID)) {
                    $("#teamAnalysis.team-analysis-" + offer.pointer + " #teamAnalysisList").show();
                    if (offer.teamAnalysisModal) {
                        $("#teamAnalysis").addClass("modal-type").prependTo("#sportsBook #" + offer.pointer)
                            .find(".team-analysis-button").addClass("team-analysis-opened team-analysis-region");
                    } else {
                        $("#teamAnalysis.team-analysis-" + offer.pointer + " .team-analysis-button")
                            .addClass("team-analysis-opened team-analysis-region").prependTo("#sportsBook #" + offer.pointer);

                    }
                }

                if (stored.isMatchesFilterActive) {
                    // scroll pre 'zacinajuce zapasy' menu obsahuje EventsFilter
                    shared.scrollModule.scrollButtons("offer", sets.offerMenuHeight1920x1080 - 61);
                } else {
                    // scroll pre ponuku s plnou vyskou menu neobsahuje EventsFilter
                    shared.scrollModule.scrollButtons("offer", sets.offerMenuHeight1920x1080);
                }

                // Nastavi ikonky ligovych tabuliek
                $('#sportsBook .stats-table-ico').each(function(s, statsIco) {
                    $(statsIco).closest('summary').append(statsIco);
                });

                // Odomkne content-offer (zamyka sa nezavysle od #sportsBook)
                $(".content-offer").removeClass("ui-disabled");
                return true;

            } else {
                main.setPage(2);
                $(".content-offer").removeClass("ui-disabled");
                modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.setPage(2);
            $(".content-offer").removeClass("ui-disabled");
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return false;
        }
    },

    // Funkcia na aktualizaciu sum o pocte zapasov v strome KURZOVEJ PONUKY
    sportsBookSum(sub, data) {
        try {
            if (data) {
                switch (sub) {
                    case "a":
                        if (data[0].Order == -1)
                            $("#sportsBook #" + offer.pointer).find("#sumSport").text(data[0].EventCount);
                        break;
                    case "b":
                        if (data[0].Order == -1 && data[1].Order == -1)
                            $("#sportsBook #" + offer.pointer).find("#sumRLa").text(data[1].EventCount)
                                .parents(".SB-level-root").find("#sumSport").text(data[0].EventCount);
                        break;
                }
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false
        }
    },

    // Funkcia na zobrazenie filtra v menu "zacinajuce zapasy" a "neskor"
    matchesFilter(date, filterButtonIndex) {
        try {
            offer.lastSportID = offer.sportID.toString();
            offer.date = date;
            $("#eventsFilter a").removeClass('selected');

            service.loadPure('sportsBook');

            if (offer.page == "lastMinute") {
                // Popisky
                $("#events #noEvents h1").html(texts.OfferMsgT);
                $("#events #noEvents .message").html(texts.OfferMsgStartingMatches);
            } else if (offer.page == "otherDates") {
                // Popisky
                $("#events #noEvents h1").html(texts.OfferMsgT);
                $("#events #noEvents .message").html(texts.OfferMsgOtherDates);
            }
            $("#eventsFilter #button" + filterButtonIndex + "Filter").addClass('selected');
            // GA4 - ulozenie filtra pre document.title po user action nie po nacitani screen
            if (event?.type === "mousedown" && event?.target.closest('#eventsFilter')) {
                stored.screenFilter = "filter:" + (filterButtonIndex*1 + 1);
                communication.dataTrackModule.setScreenPath(0, "");
            }
            return true;
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia vrati datum vo formate YYYY-MM-DD
    getDateAfterDays(daysAfterToday) {
        try {
            tempDate = new Date(today);
            new Date(tempDate.setDate(today.getDate() + daysAfterToday));
            return tempDate.getFullYear() + "-"
            + ("0" + (tempDate.getMonth() + 1)).slice(-2) + "-"
            + ("0" + tempDate.getDate()).slice(-2); 
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Handler pre toggle event na prvej úrovni (šport)
    on1stLevelToggle(element) {
        try {
            if (element.open) {
                // Rozbalenie
                $(".content-offer, #sportsBook, #events").addClass("ui-disabled");
                $("#footer").addClass("lock-btn");
                // Nastavenie pointera pred asynchrónnym volaním
                offer.pointer = $(element).attr("id");
                service.loadPure('sportsBookRegions', offer.pointer);
                $(element).find("summary.sport").attr("onclick", "sportsbook.levelUp(" + $(element).attr("id") + ");");
                communication.dataTrackModule.setScreenPath(0, $(element).find("[sport-name-full]").text());
            } else {
                // Zatvorenie
                $(element).find("summary.sport").removeAttr("onclick");
                communication.dataTrackModule.setScreenPath(0, "");
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Handler pre toggle event na druhej úrovni (región)
    on2ndLevelToggle(element) {
        try {
            if (element.open) {
                // Rozbalenie
                $(".content-offer, #sportsBook, #events").addClass("ui-disabled");
                $("#footer").addClass("lock-btn");
                // Nastavenie pointera pred asynchrónnym volaním
                offer.pointer = $(element).attr("id");
                service.loadPure('sportsBookLeagues', offer.pointer);
                communication.dataTrackModule.setScreenPath(1, $(element).find("#SBTa").text());
            } else {
                // Zatvorenie
                $(element).find("summary.sb-level-a-summary").removeAttr("onclick");
                communication.dataTrackModule.setScreenPath(1, "");
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Handler pre toggle event na tretej úrovni (liga)
    on3rdLevelToggle(element) {
        try {
            if (element.open) {
                // Rozbalenie
                $("#sportsBook, #events").addClass("ui-disabled");
                $("#footer").addClass("lock-btn");
                // Nastavenie pointera pred asynchrónnym volaním (fix race condition)
                offer.pointer = $(element).attr("id");
                service.loadPure('sportsBookEvents', offer.pointer);
                // Akordeon - zatvori ostatne elementy
                // TODO - po update EO-browser upravit handlovanie pomocou atributu name
                $(element).parent().children("details:not(#" + $(element).attr("id") + ")").removeAttr("open");
                // Nastavi onclick pre levelUp navigaciu (po načítaní dát)
                var levelUpId = $(element).parents(".SB-level-a").attr("id");
                var levelUpIdRoot = $(element).parents(".SB-level-root").attr("id");
                // $("#sportsBook summary[onclick]").removeAttr("onclick");
                $(element).find("summary.sb-level-b-summary").attr("onclick", "sportsbook.levelUp(" + $(element).attr("id") + ");");
                $($(element).parents(".SB-level-a").find("summary.sb-level-a-summary")[0]).attr("onclick", "sportsbook.levelUp(" + levelUpId + ");");
                $($(element).parents(".SB-level-root").find("summary.sb-level-root-summary")[0]).attr("onclick", "sportsbook.levelUp(" + levelUpIdRoot + ");");
                // Popisky
                communication.dataTrackModule.setScreenPath(2, $(element).find("#SBTb").text());
            } else {
                // Zatvorenie - odstránime onclick aby sa element dal znova otvoriť
                $(element).find("summary.sb-level-b-summary").removeAttr("onclick");
                communication.dataTrackModule.setScreenPath(2, "");
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
